module.exports = __webpack_public_path__ + "img/a666@2x.855da11b.png";